module.exports = __webpack_public_path__ + "img/logo.bd37ef6b.png";